import React from 'react';
import { Layout, Card, Grid } from '@enterprise-ui/canvas-ui-react';
import SectionHeader from './SectionHeader.js';

// eslint-disable-next-line no-unused-vars
var ErrorContent = function ErrorContent(_ref) {
  var error = _ref.error;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionHeader, {
    pageHeading: "Error"
  }), /*#__PURE__*/React.createElement(Layout.Body, {
    "data-testid": "layoutWithErrorContent"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement("p", null, "Your error content: ", error.message))))), /*#__PURE__*/React.createElement(Layout.Rail, {
    "data-testid": "layoutWithErrorRailContent"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement("p", null, "Your help content"))))));
};

export { ErrorContent as default };
